import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialModule } from '../../material/material.module';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ConfirmActionDialogComponent } from './confirm-action-dialog/confirm-action-dialog.component';
import { LoaderService } from './loader/loader.service';
import { ConfirmDialogComponent } from './confirm-dialog/confirm-dialog.component';
import { ProjectTotalsDialogComponent } from './project-totals-dialog/project-totals-dialog.component';
import { BreakInOutTotalsDialogComponent } from './break-in-out-totals-dialog/break-in-out-totals-dialog.component';
import { NewBreakInOutDialogComponent } from './new-break-in-out-dialog/new-break-in-out-dialog.component';
import { ConfirmDialog2Component } from './confirm-dialog-2/confirm-dialog-2.component';
import { DisplayColumnsDialogComponent } from './display-columns-dialog/display-columns-dialog.component';
import { OnlyNumbersDirective } from './directives/only-numbers.directive';
import { OnlyDigitsDirective } from './directives/only-digits.directive';
import { FilterDialogComponent } from './filter-dialog/filter-dialog.component';
import { ConfirmDuplicationDialogComponent } from './confirm-duplication-dialog/confirm-duplication-dialog.component';
import { KCurrencyDirective } from './directives/k-currency.directive';
import { CompactCurrencyPipe } from './pipes/compact-currency.pipe';
import { ColumnResizeDirective } from './directives/column-resize.directive';
import { CommentDialogComponent } from './comment-dialog/comment-dialog.component';
import { AccountingPipe } from './pipes/accounting.pipe';
import { TranslateModule } from '@ngx-translate/core';
import { InfoDialogComponent } from './info-dialog/info-dialog.component';
import { StripHtmlPipe } from './pipes/striphtml.pipe';
import { JldColumnResizeDirective } from './directives/jld-column-resize.directive';
import { EditBreakInOutDialogComponent } from './edit-break-in-out-dialog/edit-break-in-out-dialog.component';
import { FilterBannerComponent } from './filter-banner/filter-banner.component';

@NgModule({
  declarations: [
    ConfirmActionDialogComponent,
    ConfirmDuplicationDialogComponent,
    ConfirmDialogComponent,
    ProjectTotalsDialogComponent,
    BreakInOutTotalsDialogComponent,
    NewBreakInOutDialogComponent,
    ConfirmDialog2Component,
    DisplayColumnsDialogComponent,
    FilterDialogComponent,
    CommentDialogComponent,
    InfoDialogComponent,
    EditBreakInOutDialogComponent,
    FilterBannerComponent,
    OnlyNumbersDirective,
    OnlyDigitsDirective,
    KCurrencyDirective,
    CompactCurrencyPipe,
    ColumnResizeDirective,
    AccountingPipe,
    StripHtmlPipe,
    JldColumnResizeDirective,
  ],
  exports: [FilterBannerComponent, OnlyNumbersDirective, OnlyDigitsDirective, KCurrencyDirective, CompactCurrencyPipe, ColumnResizeDirective, AccountingPipe, StripHtmlPipe, JldColumnResizeDirective, TranslateModule],
  imports: [MaterialModule, CommonModule, ReactiveFormsModule, FormsModule, TranslateModule],
  providers: [
    {
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
      useValue: {
        subscriptSizing: 'dynamic',
      },
    },
    LoaderService,
  ],
})
export class SharedModule {}
